import React, { useEffect, useState } from "react";
import { enterFullscreen } from "../../../utils/deviceManagement";
import { Button } from "../../../components/Button";
import { useSelector } from "react-redux";
import { selectTranslations } from "../../../services/i18n/i18nSlice";

const FullScreenCheck = () => {
  const [isFullScreen, setIsFullScreen] = useState(true);

  const t = useSelector(selectTranslations)

  const checkFullScreen = () => {
    const fsElement =
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement;

    setIsFullScreen(!!fsElement);
  };

  useEffect(() => {
    checkFullScreen(); // Verifica iniziale

    const handleChange = () => checkFullScreen();

    document.addEventListener("fullscreenchange", handleChange);
    document.addEventListener("webkitfullscreenchange", handleChange);
    document.addEventListener("mozfullscreenchange", handleChange);
    document.addEventListener("MSFullscreenChange", handleChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleChange);
      document.removeEventListener("webkitfullscreenchange", handleChange);
      document.removeEventListener("mozfullscreenchange", handleChange);
      document.removeEventListener("MSFullscreenChange", handleChange);
    };
  }, []);

  if (isFullScreen) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "black",
        color: "white",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "1.5rem",
        zIndex: 9999,
        padding: "2rem",
        textAlign: "center",
      }}
    >
      <p>{t.fullscreen.alert}</p>
      <Button onClick={enterFullscreen}>{t.fullscreen.re_start}</Button>
    </div>
  );
};

export default FullScreenCheck;